import { promotionConstants } from './promotions'
import { pushNotification } from './pushNotification'
import { customConstants } from './common'
import { storeConstants } from './stores'
import { productsConstants } from './products'
import { productMeasurements } from './productMeasurements'
import { appRoutes } from './appRoutes'
import { permissions } from './permissions'
import { configurations } from './configurations'
import { ManageImports } from './ManageImports'
import { ManageStoresImports } from './ManageStoresImports'
import { ManageProductsImports } from './ManageProductsImports'
import { Orders } from './orders'
import { ManageInventoryImports } from './ManageInventoryImports'
import { productImport } from './productImport'
import { nutritionImport } from './nutritionImport'

export const constants = {
    ...promotionConstants,
    ...pushNotification,
    ...customConstants,
    ...storeConstants,
    ...productMeasurements,
    ...productsConstants,
    ...appRoutes,
    permissions,
    ...configurations,
    ...ManageImports,
    ...ManageStoresImports,
    ...ManageProductsImports,
    nutritionImport,
    ...Orders,
    ...ManageInventoryImports,
    ...productImport,
}
